import type { CreditBalanceSummaryResponse } from "@/types/creditBalance";

import type { APIInstance } from "./apiService";

export class CreditBalanceService {
  private api: APIInstance;

  constructor(api: APIInstance) {
    this.api = api;
  }

  async getCreditBalance(firmId: string): Promise<CreditBalanceSummaryResponse> {
    const response = await this.api.get<CreditBalanceSummaryResponse>(
      `/firms/${firmId}/credit-balance`
    );
    return response.data;
  }
}
